import { useQuery } from 'react-query';
import { getPhotoCardMarketData } from '../apis/getPhotoCardMarketData';

export const usePhotoCardMarketQuery = (tabType: string) => {
  return useQuery({
    queryKey: ['photoCardMarket', tabType],
    queryFn: () => getPhotoCardMarketData(tabType)
  });
};
